export const post = {
  slug: "founder-logs-day-88-batting-practice",
  title: "Founder Logs Day 88 - Batting Practice",
  contentType: "article",
  excerpt:
    "A worksheet framework for deliberate practice. Create a process so you can learn from the Pros and build a methodology at your skill level.",
  categories: ["FounderLogs", "E. x . O.", "Personal Growth"],
  tags: [
    "deliberate-practice",
    "founder-logs",
    "voice-acting",
    "worksheet",
    "exoHighPriestess",
    "exocreateRoutine",
  ],
  author: {
    name: "Kiarra Martin",
    email: "support@team.exohaven.online",
  },
  publishedAt: "2026-01-30",
  status: "published",
  isTemplate: false,
  featuredImage: "",
  content: `
# Founder Logs Day 88 - Batting Practice

Okay, so...

Let's try this.

**Duplicate and update the worksheet**

---

## Objective

Create a worksheet that someone can use to document a process, so they can learn from a Pro - and build a methodology that is at their skill level.

---

## Process Worksheet - Creating Audios

**Objective:** As a voice actor, I often need to embody a single persona for an extended period of time. This is a "batting machine" that pitches audios at you so you can practice improv on your feet. It takes personas with backstories, surprises you by switching up categories.

**This is practice for dueling at exoHaven.**

You can tune the difficulty up or down as you go.

---

### Recording & Sharing

If you are going to record audios for posting to social media, you can replay them after. You can record these to share as "practice", with higher quality versions costing more - don't focus on editing and trying to get everything studio quality when you're still learning the ropes.

**The people who love you for who you are, will love seeing you learning and staying on schedule.**

---

### The Process

1. **Create or select a persona**
2. **Record yourself on Camera**
3. **Review & take notes**
4. **Optionally, share your work!**

*(Review - critique and mark down what was really good, specifically if the practice did well, what did people like, and what made them come back?)*

You can stitch together multiple of these if the platform you are posting on is looking for longer videos.

---

## DN-Framework Week 1 - Procedure Worksheet

**Game:** Professional Voice Acting Practice

**Target:** I will complete a few rounds once a day for 15-30 minutes.

---

### Desires/Policies

I will:

- Joyfully record myself, no pouting, complaints, or excuses
- Record myself on video so I can critique my attitude week-by-week
- Share my work so I can take pride in my weekly practice and discipline
- If I miss a day and remember, it's just practice, you can do double next time
- Do my best to handle interruptions with grace; it's just practice. No one can stop you from finding time, but yourself.

---

### Narrative/Process

#### 𝓒𝓻𝓮𝓪𝓽𝓮 𝓸𝓻 𝓼𝓮𝓵𝓮𝓬𝓽 𝓪 𝓹𝓮𝓻𝓼𝓸𝓷𝓪

(started 9:13PM) - launch exoCreate at 11PM after fixing the codebase with claude.

For now, touch up makeup, write your own, and go from there (if the universe allows it).

Use exoHaven framework if you have to, it's better than letting the code and distractions win.

Store in exoHaven.

#### 𝓡𝓮𝓬𝓸𝓻𝓭 𝔂𝓸𝓾𝓻𝓼𝓮𝓵𝓯 𝓸𝓷 𝓒𝓪𝓶𝓮𝓻𝓪

#### 𝓡𝓮𝓿𝓲𝓮𝔀 & 𝓽𝓪𝓴𝓮 𝓷𝓸𝓽𝓮𝓼

#### 𝓸𝓹𝓽𝓲𝓸𝓷𝓪𝓵𝓵𝔂, 𝓼𝓱𝓪𝓻𝓮 𝔂𝓸𝓾𝓻 𝔀𝓸𝓻𝓴!

[List platforms and processing as well as uploading]

---

## 𝕁𝕠𝕦𝕣𝕟𝕒𝕝

**Thursday Jan 29th, 2026**

Right now my software for this down. I really need to simplify it, get back to using mongoDb for now so I can prototype, as well as push updates quickly without migration issues.

AI hosting

---

*#FounderLogs #BattingPractice #exoHighPriestess*
  `.trim(),
};

export default post;
